import template from './adatbiztonsagi-kviz-legacy.pug';
if ('customElements' in window && (document.head.createShadowRoot || document.head.attachShadow)) {
	const html = document.querySelector('html');
	html.style.scrollBehavior = 'smooth';
	import(/* webpackChunkName: 'externals/adatbiztonsagi-kviz-lazy' */ '@otp-dev/adatbiztonsagi-kviz');
} else {
	const element = document.querySelector('otp-adatbiztonsagi-kviz');
	if (element) {
		element.innerHTML = template;
	}
}
